// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_47d1cd66","circle":"_86974d27","circleDouble":"_ae6a3792","circlePoints":"_4560cd8","copy":"_332f2b10","double":"_456d7680","divider":"_78733734"};